export const mediaQueries = { mobile: '(max-width: 800px)' };
